import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import GET_SHOPPING_LIST_COUNT from "../../operations/queries/operations/queries/get-shopping-list-count.js";
const useGetShoppingListCount = (wishlistId, clearWishlist) => {
  const { locale } = useIntl();
  const [hasBeenTriggered, setHasBeenTriggered] = React.useState(false);
  const [trigger, { data, refetch }] = useLazyQuery(GET_SHOPPING_LIST_COUNT, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    fetchPolicy: "no-cache",
    onCompleted: (data2) => {
      if (data2.shoppinglistById.failure?.__typename === "ShoppinglistNotFoundFailure") {
        clearWishlist?.();
      }
    }
  });
  React.useEffect(() => {
    if (wishlistId && wishlistId.trim() !== "") {
      setHasBeenTriggered(true);
      trigger({
        variables: {
          shoppinglistId: wishlistId
        }
      });
    }
  }, [trigger, wishlistId]);
  useWishlistId(hasBeenTriggered ? refetch : void 0);
  return {
    itemsCount: data?.shoppinglistById.shoppinglist?.itemsCount
  };
};
export {
  useGetShoppingListCount
};
//# sourceMappingURL=use-get-shopping-list-count.js.map
